export default __webpack_public_path__ + "static/media/logo.bc9b889d.webp";